import { render, staticRenderFns } from "./RbxExtendedTextarea.vue?vue&type=template&id=7ef1d1c0&"
import script from "./RbxExtendedTextarea.vue?vue&type=script&lang=js&"
export * from "./RbxExtendedTextarea.vue?vue&type=script&lang=js&"
import style0 from "./RbxExtendedTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxExtendedTextarea.vue"
export default component.exports